<template>
  <div class="search">
    <SearchBar :showCategoriesMenu="false" />
    <v-container class="py-0 py-md-3">
      <v-row class="py-2" v-if="$vuetify.breakpoint.smAndUp">
        <breadcrumbs class="px-0" :breadcrumbs="breadcrumbs" />
      </v-row>
      <ais-instant-search :search-client="searchClient" :middlewares="middlewares" index-name="products"
        :stalled-search-delay="200" :showLoadingIndicator="true" class="flex" :routing="routing">
        <ais-configure :clickAnalytics="true" />
        <v-row class="filter-content">
          <v-col cols="12" md="3" class="py-0 py-md-3 pl-0">
            <div class="filter-options d-sm-block mt-2 mt-sm-0">
              <h2 class="d-none d-md-block">
                <ais-stats>
                  <template v-slot="{ nbHits}">
                    {{ nbHits }} Products Found
                  </template>
                </ais-stats>
              </h2>
              <div class="filter-options-container">

                <div class="d-flex d-md-block align-center justify-center">
                  <ais-search-box class="flex px-3 px-5" :showLadingIdicator="true" :autofocus="true"
                    placeholder="Search" index-name="instant_search" />
                  <div class="d-block d-md-none">
                    <v-btn color="amber darken-1" fab small elevation="0" tile dark @click="showFilters=!showFilters">
                      <v-icon dark>
                        mdi-tune-vertical
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
                <div v-show="showFilters" class="px-5">
                  <ais-range-input attribute="amount">
                    <template v-slot="{ currentRefinement, range, refine }">
                      <div class="title-with-clear mt-5 mb-2">
                        <div class="flex d-flex justify-space-between">
                          <h2>
                            Prices
                          </h2>
                          <div class="min-max">
                            £{{ toValue(currentRefinement, range)[0] }} - £{{ toValue(currentRefinement, range)[1] }}
                          </div>
                        </div>
                      </div>
                      <div class="brands-content">

                        <v-range-slider :min="range.min" :max="range.max" :hide-details="true"
                          :value="toValue(currentRefinement, range)"
                          @change="refine({ min: $event[0], max: $event[1] });changeMinMax($event)" color="appGreen"
                          track-color="appGreen lighten-2"></v-range-slider>

                      </div>

                    </template>
                  </ais-range-input>




                  <div class="title-with-clear mt-5 mb-2">
                    <h2>
                      Brands


                    </h2>
                  </div>
                  <div class="brands-content">

                    <ais-refinement-list attribute="brand.name" :sortBy="['name:asc']" />
                  </div>

                  <div class="title-with-clear mt-5 mb-2">
                    <h2>
                      Categories

                    </h2>
                  </div>

                  <div class="brands-content">
                    <ais-refinement-list attribute="subCategories.category.name" :sortBy="['name:asc']" />


                  </div>

                  <div class="title-with-clear mt-5 mb-2">
                    <h2>
                      Subcategories

                    </h2>
                  </div>

                  <div class="brands-content">
                    <ais-refinement-list attribute="subCategories.name" :sortBy="['name:asc']" />


                  </div>

                  <div class="title-with-clear mt-5 mb-2">
                    <h2>
                      Types


                    </h2>
                  </div>

                  <div class="brands-content">
                    <ais-refinement-list attribute="subCategories.productSubCategoryType.name" :sortBy="['name:asc']" />


                  </div>
                </div>
              </div>
            </div>

          </v-col>
          <v-col cols="12" md="9" class="pa-0 results-container">
            <div class="filter-results pa-0 py-sm-3">
              <div class="results-title mr-0" v-if="$vuetify.breakpoint.smAndUp">
                <ais-stats>
                </ais-stats>
                <div class="sort-options">
                  <h3>Sorted By:</h3>
                  <ais-sort-by :items="[
                      { value: 'product', label: 'Sort by', text: 'Sort By' },
                      { value: 'amount_asc', label: 'Price asc.', text: 'Price - Low to High' },
                      { value: 'amount_desc', label: 'Price desc.', text: 'Price - High to Low' },
                      { value: 'name_asc', label: 'Name asc.', text: 'Name - A to Z' },
                      { value: 'name_desc', label: 'Name desc.', text: 'Name - Z to A' },
                    ]">
                    <template v-slot="{ items, refine }">
                      <v-select :items="items" v-model="items[0].value" label="Categories" @input="refine($event.value)"
                        solo outlined rounded dense return-object flat hide-details="auto"></v-select>
                    </template>
                  </ais-sort-by>
                </div>
              </div>

              <div class="results">
                <div class="filter-options d-sm-block mt-0 mt-sm-0">
                  <div class="search-panel__filters">
                  </div>
                  <v-container fluid class="bg-white py-0 px-0">

                    <div class="products-view">
                      <ais-hits :class-names="{
                                'ais-Hits': 'row d-block mx-0',
                                'ais-Hits-list': 'row d-flex',
                                'ais-Hits-item': 'col-sm-6 col-md-6 col-lg-4 col-xl-3 col-12 pr-0'
                              }">
                        <template v-slot:item="{ item }">
                          <product-card :key="item.id" :product="item" />
                        </template>
                      </ais-hits>
                    </div>

                  </v-container>
                </div>
              </div>
            </div>
            <div class="pagination px-0 d-flex align-center justify-space-between">
              <ais-pagination>
                <template v-slot="{
                    nbPages,
                    refine
                  }">
                  <div class="pagination-container">
                    <v-container class="max-width">
                      <v-pagination color="#23A0A0" v-model="page" @input="refine($event - 1)" :length="nbPages"
                        next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" :total-visible="10"></v-pagination>
                    </v-container>
                  </div>
                </template>
              </ais-pagination>
            </div>

          </v-col>

        </v-row>
      </ais-instant-search>

    </v-container>
    <v-container fluid class="pa-0">
      <home-footer class="d-none d-md-block" />
    </v-container>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Breadcrumbs from "@/components/Shared/Breadcrumbs/Breadcrumbs.vue";
  import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
  import ProductCard from "@/components/Shared/ProductCard/ProductCard.vue";
  import "instantsearch.css/themes/satellite-min.css";
  import algoliasearch from "algoliasearch/lite";
  import "instantsearch.css/themes/satellite-min.css";
  import VueCookie from "vue-cookie";
  import auth from "@/auth/auth.js";
  import {
    history
  } from 'instantsearch.js/es/lib/routers';
  import {
    simple
  } from 'instantsearch.js/es/lib/stateMappings';
  import SearchBar from "@/components/SearchBar/SearchBar.vue";

  const aa = require("search-insights");

  aa("init", {
    appId: process.env.ALGOLIA_APP_ID,
    apiKey: process.env.ALGOLIA_ANALYTICS_KEY
  });

  if (VueCookie.get("token")) {
    aa("setUserToken", auth.decodeToken(VueCookie.get("token")).uid);
  }

  import {
    createInsightsMiddleware
  } from "instantsearch.js/es/middlewares";

  const insightsMiddleware = createInsightsMiddleware({
    insightsClient: aa
  });

  export default {
    name: "SearchComponent",
    props: {
      category: {
        type: String,
        default: null
      },
      subcategory: {
        type: String,
        default: null
      }
    },
    components: {
      Breadcrumbs,
      HomeFooter,
      ProductCard,
      SearchBar
    },
    data: () => ({
      middlewares: [insightsMiddleware],
      searchClient: algoliasearch(
        process.env.ALGOLIA_APP_ID,
        process.env.ALGOLIA_API_KEY
      ),
      page: 1,
      totalVisible: 8,
      showFilters: true,
      routing: {
        router: history(),
        stateMapping: simple(),
      },
      min: 0,
      max: 0
    }),
    filters: {
      trim: function (val) {
        return val.trim().slice(0, 100);
      },
    },
    computed: {
      ...mapState({
        products: state => state.product.products,
        categories: state => state.product.categories,
        subCat: state => state.product.category
      }),
      breadcrumbs() {
        return this.category ? [this.category, this.subcategory] : ["Category", "Subcategory"];
      }
    },

    methods: {
      navigateToProductPage(item, sendEvent) {
        this.evtCatalogueItemSelected(item);
        sendEvent("click", item, "Search Result Clicked");
        this.$router.push({
          name: "Product",
          params: {
            id: this.convertToSlug(item.name) + "-" + item.id
          }
        });
      },
      convertToSlug(Text) {
        return Text.toLowerCase()
          .replace(/[^\w ]+/g, "")
          .replace(/ +/g, "-");
      },
      toValue(value, range) {
        return [
          typeof value.min === "number" ? value.min : range.min,
          typeof value.max === "number" ? value.max : range.max,
        ];
      },
      changeMinMax(event) {
        this.min = event[0]
        this.max = event[1]
      }
    }
  };
</script>
<style scoped lang="scss" src="./Search.scss"></style>
<style lang="scss">
  .search {
    .v-input {

      .v-label,
      input {
        font-size: 14px;
        font-family: Gotham-Book;
      }
    }

    .search-input {
      .v-input__slot {
        background: #f9f9f9 !important;
      }
    }

    .search-bar {
      background: #00536d;
      width: 100%;
      padding: 25px;
      margin: 0;
      position: relative;
    }

    .ais-SearchBox-input {
      background-color: #fff;
      color: #23263b !important;
      width: 100%;
      font-family: "Gotham-Book";
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      border: none;
      box-shadow: none !important;
      border-radius: 30px;
      /* or 162% */
      padding: 1rem !important;
      letter-spacing: -0.3px;
      border: 1px solid #626262;
      border-radius: 25px;

      @media all and (max-width: 676px) {
        background-color: #F9F9F9;
        border-radius: 5px;
        padding-left: 1rem;
        color: #000 !important;
      }
    }

    .ais-InstantSearch {
      position: relative;
    }

    .ais-SearchBox-form {
      background-color: initial !important;
    }

    .ais-SearchBox-form:before {
      content: none;
    }

    @media all and (max-width: 676px) {
      .ais-SearchBox-form:before {
        content: none;
      }

      .ais-SearchBox-form:after {
        content: "";
        height: 1rem;
        right: 1rem;
        margin-top: -0.5rem;
        position: absolute;
        top: 50%;
        width: 1rem;
        background: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.8047 14.862L11.2547 10.312C12.136 9.22334 12.6667 7.84 12.6667 6.33334C12.6667 2.84134 9.82532 0 6.33332 0C2.84131 0 0 2.84131 0 6.33331C0 9.82531 2.84135 12.6667 6.33335 12.6667C7.84001 12.6667 9.22335 12.136 10.312 11.2547L14.862 15.8047C14.992 15.9347 15.1627 16 15.3334 16C15.504 16 15.6747 15.9347 15.8047 15.8047C16.0654 15.544 16.0654 15.1227 15.8047 14.862ZM6.33335 11.3333C3.576 11.3333 1.33334 9.09066 1.33334 6.33331C1.33334 3.57597 3.576 1.33331 6.33335 1.33331C9.09069 1.33331 11.3334 3.57597 11.3334 6.33331C11.3334 9.09066 9.09066 11.3333 6.33335 11.3333Z' fill='grey'/%3E%3C/svg%3E%0A");
      }
    }

    .ais-SearchBox-input::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #7A7773;
      ;
      opacity: 1;
      /* Firefox */
    }

    @media all and (max-width: 676px) {
      .ais-SearchBox-input::placeholder {
        color: #7A7773;
        ;
      }
    }

    .ais-Hits-list {
      padding-left: 0px;
      width: 100%;
      max-height: 400px;
      overflow-y: auto;
      z-index: 1000;
    }

    .ais-Hits {
      z-index: 1000;
      max-width: 100%;
    }

    @media (max-width: 678px) {
      .ais-Hits {
        border-radius: 10px;
      }

      .ais-RefinementList-list {
        padding-left: 0px;
      }
    }
  }

  .slide-enter-active {
    transition: all 0.5s ease-in;
    top: 100% !important;
  }

  .slide-enter-to {
    top: 38px !important;
  }

  .slide-leave-active {
    transition: all 0.5s ease-in;
    top: 38px !important;
  }

  .slide-leave-to {
    top: 100% !important;
  }

  .ais-Pagination .pagination-container {
    .container.max-width {
      padding: 0px;
    }
  }

  .v-card.product-card {
    border-radius: 10px;
    border: 0;
    box-sizing: border-box;
    margin: 0 !important;
    width: 100%;
    max-width: unset !important;
    // filter: drop-shadow(2px 3px 7px rgba(0, 0, 0, 0.1));
    position: relative;

    .card-logo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 16px;

      .v-icon {
        color: rgba(170, 170, 170, 0.5);
        cursor: pointer;
      }
    }

    .product-image-container {
      height: 260px;

      .product-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        object-fit: cover;
      }
    }

    .v-image {
      position: relative;
      height: 266px;
    }

    .v-card__text {
      padding: 15px 15px 7px 16px;
    }

    .v-card__actions {
      padding: 12px;

      .v-btn {
        width: 100%;
        background-color: var(--v-appGreen-base);
        border-radius: 8px;
        font-size: 12px;
      }
    }

    .product-tag {
      font-size: 12px;
      font-family: Gotham-Book;
    }

    .product-price {
      color: var(--v-appGreen-base);
      font-size: 18px;
    }

    .product-sales {
      font-size: 12px;
      color: #999;
    }
  }

  .browse-products {
    border: 2px solid currentColor;
    text-transform: none;
  }

  .product-card {
    min-height: 400px;

    .product-title {
      --max-lines: 2;
      position: relative;
      max-height: calc(1.4em * var(--max-lines));
      overflow: hidden;
      padding-right: 1rem;
      /* space for ellipsis */
      min-height: 44px;
    }

    .product-title::before {
      position: absolute;
      content: '';
      /*   inset-block-end: 0;
		inset-inline-end: 0; */
      bottom: 0;
      right: 0;
    }

    .product-title::after {
      content: "";
      position: absolute;
      /*   inset-inline-end: 0; */
      right: 0;
      width: 1rem;
      height: 1rem;
      background: white;
    }

    .product-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      left: 0;
      padding: 0 10px;
    }
  }

  .ais-Hits-item:first-of-type,
  .ais-InfiniteHits-item:first-of-type,
  .ais-Hits-item {
    border-radius: unset;
    box-shadow: none;
    padding: 0.5rem;
  }

  .search .ais-Hits-list {
    max-height: unset;
  }

  @media (max-width: 678px) {
    .search .ais-Hits {
      border-radius: 10px;
      margin: 0;
    }
  }

  .ais-GeoSearch-input:checked,
  .ais-RefinementList-item--selected .ais-RefinementList-checkbox {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='15' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
    background-size: 13px;
    border-color: currentcolor;
    box-shadow: inset 0 1px 0 0 rgb(35 38 59 / 5%);
    color: #fff;
    background-position: center;
    background-color: #23a0a0;
    border: 2px solid #23a0a0;
  }

  .ais-GeoSearch-input,
  .ais-RefinementList-checkbox {
    border: 2px solid #23a0a0;
    box-shadow: none !important;
  }

  ul.ais-RefinementList-list {
    padding-left: 0px;
  }

  .min-max {
    font-family: 'Gotham-Medium';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    color: #23A0A0;
  }

  .ais-RefinementList-count {
    font-family: 'Gotham-Medium';
    font-style: normal;

    background-color: #23A0A0;
    color: #FFFFFF
  }
</style>